import { isOneOf } from './isOneOf';
import type { TraceErrorObject } from 'owa-analytics-types';

const AuthErrors: string[] = [
    'ErrorAuthNeeded',
    'AuthNeeded',
    'unknownAuthError',
    'GetAuthTokenError',
    'Loki auth token unavailable',
    'OwaAuthConcurrency',
    'GraphQL hit 401',
    'WWAuth',
    'UnauthorizedAccessException',
    'Proxy Authentication Required',
];

/** Returns true when an error represents an authentication failure. */
export function isAuthError(message: string | undefined, error?: TraceErrorObject): boolean {
    return (
        isOneOf(AuthErrors, message) ||
        error?.httpStatus === 401 ||
        error?.httpStatus === 440 ||
        error?.fetchErrorType === 'AuthNeeded' ||
        error?.responseCode === 'ErrorAuthNeeded'
    );
}
